import { render, staticRenderFns } from "./JournalNew.vue?vue&type=template&id=26fb97d0&lang=pug"
import script from "./JournalNew.vue?vue&type=script&lang=js"
export * from "./JournalNew.vue?vue&type=script&lang=js"
import style0 from "./JournalNew.vue?vue&type=style&index=0&id=26fb97d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports